import React, { useEffect, useState } from 'react';
import ls from 'local-storage';
import {
  CButton,
  CCard,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CCol,
  CCardHeader,
  CCardBody
} from '@coreui/react';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { getReprintList, getReprintSummary, getTransactionList } from 'src/services/Transactions';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import BoothPicker from 'src/components/BoothPicker';
import DownloadExcel from 'src/reusables/DownloadExcel';
import DataTable from 'src/components/DataTable';

function ReprintList() {
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');

  const [reprintRows, setReprintRows] = useState([]);
  const [excelRows, setExcelRows] = useState([]);

  const [reprintColumns, setReprintColumns] = useState([]);
  const [excelColumns, setExcelColumns] = useState([]);

  const navigate = useNavigate();
  const { height, width, comparison } = useWindowDimensions();

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);

  async function fetchReprintList(dateFrom, dateTo, id) {
    const res = await getReprintList(dateFrom, dateTo, id ?? '');

    const rows =
      res.data &&
      res.data?.map((item, i) => {
        const data = {
          id: i,
          grandTotal: formatter('currency', item?.grand_total ?? 0),
          printCount: item?.print_count,
          frameName: item.frameName,
          trxId: item.id,
          repId: item.reprint_id,
          paidAt: formatter('completeDate', item?.paidAt ?? '0000-00-00 00:00:00'),
          doneAt:
            item?.doneAt !== '0000-00-00 00:00:00'
              ? formatter('completeDate', item?.doneAt ?? '0000-00-00 00:00:00')
              : 'Not Printed Yet',
          merchantName: `${item.merchant_name} - ${item.booth_id}`
        };

        return data;
      });

    setExcelRows(rows);
    setReprintRows(rows);

    const columns = [
      { field: 'trxId', headerName: 'Transaction ID', width: '150' },
      { field: 'repId', headerName: 'Reprint ID', width: '150' },
      { field: 'merchantName', headerName: 'Merchant', width: '150' },
      { field: 'printCount', headerName: 'Print Count', width: '150' },
      { field: 'grandTotal', headerName: 'Grand Total', width: '150' },
      { field: 'frameName', headerName: 'Frame', width: '150' },
      { field: 'paidAt', headerName: 'Reprint Paid At', width: '200' },
      { field: 'doneAt', headerName: 'Transaction Done At', width: '200' }
    ];

    setExcelColumns(columns);

    setReprintColumns(columns);
    setTableLoading(false);
  }

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  function handleRowClick(params) {
    ls.set('state', params.row);
    // navigate('/transaction-details', { state: params.row });
    if (ls.get('state')) {
      window.open('/transaction-details', '_blank');
    }
  }

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
  }

  useEffect(() => {
    setTableLoading(true);
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);
    // if((refetch && renderCounter > 0) || renderCounter === 0){
    fetchReprintList(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
    setRefetch(false);
    // } else {
    // }

    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal]);

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  return (
    <div style={{ color: 'black' }}>
      <CRow>
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>
        <CCol>
          <BoothPicker />
        </CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <ReprintSummary
        dateFrom={dateRange[0].startDate}
        dateTo={dateRange[0].endDate}
        boothId={ls.get('booth')?.id ?? ''}
      />

      <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw' }}>
        <CCol xs="8">Reprint List: </CCol>
        <CCol xs="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <DownloadExcel
            rows={excelRows}
            columns={excelColumns}
            dateFrom={formatter('SQLDate', dateRange[0].startDate)}
            dateTo={formatter('SQLDate', dateRange[0].endDate)}
            excelName="Reprints Report"
            config={{ width: '20' }}
          />
        </CCol>
      </CHeader>
      <CCard style={{ textAlign: 'center' }}>
        <DataTable rows={reprintRows} columns={reprintColumns} loading={tableLoading} style={{ textAlign: 'center' }} />
        {/* <DataGrid
          rows={reprintRows}
          columns={reprintColumns}
          // onRowClick={handleRowClick}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 }
            }
          }}
          pageSizeOptions={[5, 10, 20, 25]}
          checkboxSelection
          style={{ textAlign: 'center' }}
        /> */}
      </CCard>
    </div>
  );
}

function ReprintSummary({ dateFrom, dateTo, boothId }) {
  const [contribution, setContribution] = useState('0.00');
  const [reprintRevenue, setReprintRevenue] = useState('0');
  const [reprintCount, setReprintCount] = useState('0');

  function fetchSummary(dateFrom, dateTo, boothId) {
    getReprintSummary(Moment(dateFrom).format('YYYY-MM-DD'), Moment(dateTo).format('YYYY-MM-DD'), boothId).then(
      (response) => {
        setContribution(response.data.contribution);
        setReprintRevenue(response.data.reprint);
        setReprintCount(response.data.reprint_total);
      }
    );
  }

  useEffect(() => {
    fetchSummary(dateFrom, dateTo, boothId);
  }, [dateFrom, dateTo]);

  return (
    <CCard>
      <CCardHeader>{`Summary`}</CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md={4} xs={12}>
            <h4>Reprints : {formatter('number', reprintCount)}</h4>
          </CCol>
          <CCol md={4} xs={12}>
            <h4>Revenue : {formatter('currency', reprintRevenue)}</h4>
          </CCol>
          <CCol md={4} xs={12}>
            <h4>Contribution : {`${contribution}%`}</h4>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
}

export default ReprintList;
